<template>
  <div class="vertical-stepper">
    <div class="status-item" v-for="(step, i) in steps" :key="i">
      <div class="status-img">
        <img
          src="@/assets/images/check-alert.png"
          class="img-delegado"
          v-if="stepHasProblem(i + 1)"
        />
        <img
          src="@/assets/images/checked.png"
          class="img-delegado"
          v-else-if="stepDone(i + 1)"
        />
        <img src="@/assets/images/unchecked.png" class="img-delegado" v-else />
      </div>
      <div class="status-text">
        <b>{{ step }}</b>
      </div>
      <div class="status-line-container" v-if="i !== steps.length - 1">
        <div
          class="status-line"
          :class="{ done: stepDone(i + 1), problem: stepHasProblem(i + 1) }"
        >
          &nbsp;
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      steps: {
        type: Array,
        required: true,
      },
      currentStep: {
        type: Number,
        required: false,
        default: 0,
      },
      alerts: {
        type: Array,
        required: false,
        default: () => [],
      },
    },
    methods: {
      stepDone(step) {
        return this.currentStep >= step
      },
      stepHasProblem(step) {
        return (
          this.currentStep > step && !!this.alerts.find((item) => item === step)
        )
      },
    },
  }
</script>

<style lang="scss" scoped>
  .vertical-stepper {
    .status-img,
    .status-text {
      display: inline-block;
    }

    .status-text {
      font-size: 0.8rem;
      margin-left: 5px;
    }

    .status-img img {
      width: 20px;
      height: 20px;
    }

    .status-line {
      background-color: #909090;
      width: 4px;
      height: 44px;
      border-radius: 4px;
      margin-left: 7px;
      margin-top: 4px;
      margin-bottom: 4px;

      &.done {
        background-color: rgb(46, 204, 113);
      }

      &.problem {
        background-color: rgb(255, 165, 0);
      }
    }
  }
</style>
